<template>
  <div class="px-5 team-availability-view">
    <div class="flex items-center justify-between mb-4">
      <div class="max-w-xs" :class="$dm('text-bl  ack-700', 'dark:text-slate-50')" v-if="!isFullPageView">
        <!-- <div class="text-base leading-5 font-medium mb-1">
          {{
          isOnline
          ? $t('TEAM_AVAILABILITY.ONLINE')
          : $t('TEAM_AVAILABILITY.OFFLINE')
          }}
        </div> -->
        <div class="text-xs leading-4 mt-1">
          {{ replyWaitMessage }}
        </div>
      </div>
      <available-agents v-if="isOnline" :agents="availableAgents" />
    </div>
    <custom-button class="font-medium" block :bg-color="widgetColor" :text-color="textColor" @click="startConversation" style="max-width: 400px;">
      {{
        isFullPageView ? $t('CREATE_A_TICKET') : $t('START_CONVERSATION')
      }}
    </custom-button>
    <branding :disable-branding="disableBranding" v-if="isFullPageView" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getContrastingTextColor } from 'widget/helpers';
import AvailableAgents from 'widget/components/AvailableAgents.vue';
import CustomButton from 'widget/components/Button.vue';
import Branding from 'widget/components/Branding.vue';
import configMixin from 'widget/mixins/configMixin';
import availabilityMixin from 'widget/mixins/availability';
import darkMixin from 'widget/mixins/darkModeMixin.js';
import getConfig from 'widget/helpers/config';

export default {
  name: 'TeamAvailability',
  components: {
    AvailableAgents,
    CustomButton,
    Branding
  },
  mixins: [configMixin, availabilityMixin, darkMixin],
  props: {
    availableAgents: {
      type: Array,
      default: () => { },
    },
    hasConversation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disableBranding: getConfig().webChannel.disableBranding || false,
    };
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
    isOnline() {
      const { workingHoursEnabled } = this.channelConfig;
      const anyAgentOnline = this.availableAgents.length > 0;

      if (workingHoursEnabled) {
        return this.isInBetweenTheWorkingHours;
      }
      return anyAgentOnline;
    },
    replyWaitMessage() {
      return this.replyTimeStatus;
    },
    isFullPageView() {
      return getConfig().webChannel.isFullPageView;
    },
    // TODO: Re-enable once business hours are supported
    // replyWaitMessage() {
    //   const { workingHoursEnabled } = this.channelConfig;

    //   if (this.isOnline) {
    //     return this.replyTimeStatus;
    //   }

    //   if (workingHoursEnabled) {
    //     return this.outOfOfficeMessage;
    //   }

    //   return '';
    // },
  },
  methods: {
    startConversation() {
      if (this.isFullPageView) {
        this.clearConversations();
      }

      this.$emit('start-conversation');
    },
    ...mapActions('conversation', ['clearConversations']),
  },
};
</script>
<style scoped lang="scss">
.is-full-page-view {
  .team-availability-view {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: sticky;
    bottom: 0;
  }
}
</style>